import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useRoutePath } from '~/hooks/useRoutePath';

interface ErrorBoundaryRouteProps {
  is404: boolean;
  recovering?: boolean;
}

const ErrorBoundaryRoute = ({ is404, recovering }: ErrorBoundaryRouteProps) => {
  const { t } = useTranslation();
  const routePath = useRoutePath();
  if (recovering) {
    return (
      <div className="text-center py-5" role="status" aria-live="polite">
        <p className="my-5">{t('common.loading')}</p>
      </div>
    );
  }
  return (
    <>
      {is404 ? (
        <div className="text-center py-5">
          <h1>{t('pages.error.404.title')}</h1>
          <p className="my-5">{t('pages.error.404.description')}</p>
          <Button variant="primary" href={routePath('homepage')}>
            {t('pages.error.404.button')}
          </Button>
        </div>
      ) : (
        <div className="text-center py-5">
          <h1>{t('pages.error.default.title')}</h1>
          <p className="my-5">{t('pages.error.default.description')}</p>
        </div>
      )}
    </>
  );
};

export default ErrorBoundaryRoute;
